import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ServerService } from '../../../service/server/server.service';
import { RecieveDetaileComponent } from "../../../finance/finance-recieve/recieve-detaile/recieve-detaile.component";
import { WharehouseExit2Component } from '../../../wharehouse-reception/wharehouse-exit2/wharehouse-exit2.component';
import { MessageService } from '../../../service/message/message.service';

@Component({
  selector: 'app-reception-payment',
  templateUrl: './reception-payment.component.html',
  styleUrls: ['./reception-payment.component.scss']
})
export class ReceptionPaymentComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public token: any = Math.floor(Math.random() * 99999999999999);
  public loading: boolean = false;
  public delivered: boolean = false;
  public amount: number = 0;
  public sum: number = 0;
  public type_task: number = 2;
  public code: number = 160;
  public list_device_status: any = [];
  public data: any = [];
  public subscription: Subscription | any;
  public user_id!: number;
  public server_main!: string;
  public server!: string;
  public id!: number;
  public user!: number;
  public user_title!: string;
  public user_cellphone!: number;
  public shelf!: string;
  public device!: string;
  public brand!: string;
  public model!: string;
  public remain!: number;
  public id2!: number;
  public currency_title!: string;
  public result!: any;
  public shelf_temp!: number;
  public creator!: number;
  public level!: number;
  public status_empty_shelf: boolean = false;
  public discount_material: number = 0;
  public discount_services: number = 0;
  public user_sex_title!: string;
  public device_status!: number;

  constructor(
    public serverService: ServerService,
    public messageService: MessageService,
    public dialog: MatDialog,
    public router: Router,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public matDialogRef: MatDialogRef<ReceptionPaymentComponent>) {
    this.server_main = this.serverService.get_server_main();
    this.server = this.serverService.get_server();
    if (dialog_data) {
      this.id = dialog_data.id;
      this.creator = dialog_data.creator;
      this.level = dialog_data.level;
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.get_reception();
  }
  get_reception() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7278,
      'id': this.id,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.id2 = res['result'][0].repairman_reception_id2;
          this.user = res['result'][0].repairman_reception_customer;
          this.device_status = res['result'][0].repairman_reception_device_status;
          this.user_title = res['result'][0].user_title;
          this.user_sex_title = res['result'][0].user_sex_title;
          this.user_cellphone = res['result'][0].user_cellPhone;
          this.shelf = res['result'][0].repairman_shelf_title;
          this.device = res['result'][0].wharehouse_device_title;
          this.brand = res['result'][0].repairman_brand_title;
          this.model = res['result'][0].repairman_model_title;
          this.shelf_temp = res['result'][0].repairman_reception_shelf;
          this.status_empty_shelf = res['result'][0].repairman_rstatus_empty_shelf;
          this.sum = res['result'][0].repairman_reception_invoice_sum;
          this.discount_material = res['result'][0].repairman_reception_invoice_discount_material;
          this.discount_services = res['result'][0].repairman_reception_invoice_discount_service;
          this.get_balance();
          this.get_currnecy();
          this.get_device_status();
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_balance() {
    var obj = {
      'address': 1731,
      'user': this.user,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.remain = res['result'][0].balance;
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          var pe_message = "خطا در $";
          this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
        }
      }
    )
  }
  get_currnecy() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6115, creator: this.creator }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.currency_title = res['result'][0].site_currency_title;
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_device_status() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6465 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.list_device_status = [];
          for (var i = 0; i < res['num']; i++) {
            this.list_device_status.push(res['result'][i]);
          }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  show_balance_detaile() {
    window.open("/home/financial2/202?user=" + this.user, "_blank")
  }
  //************************************************************************************************** */
  update2(type: string) {
    if (type == 'delivered') {
      this.delivered = true;
    } else {
      this.delivered = false;
    }
    this.update();
  }
  update(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var x: any;
    x = "آیا شما از تحویل نهایی اطمینان دارید ؟ ";
    var confirm = window.confirm(x);
    if (confirm == true) {
      this.loading = true;
      var obj = {
        'address': 6119,
        'delivered': this.delivered,
        'id': this.id,
        'creator': this.creator,
        'device_status': this.device_status
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            var confirm_sms = false;
            if (res['result'][0].user_sms2 == 1) {
              var a; var b;
              a = "آیا میخواهید ";
              b = " از تغییر وضعیت مطلع نمائید؟";
              confirm_sms = window.confirm(a + this.user_sex_title + " " + this.user_title + b);
              res['result'][0].confirm_sms = confirm_sms;
            }
            this.result = res['result'][0];
            this.empty_shelf(this.shelf_temp, 'empty_reception');
          }//end if
          else {
            this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
          }
        }
      )
    }
  }//end recieve_data
  //************************************************************************************************** */
  new_recieve_finance() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6996,
      'user': this.user,
      'user_id': this.user_id,
      'creator': this.creator,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.open_financial(-1, 2, res['id']);
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  open_financial(i: number, type_task: number, id: number) {
    const dialogRef = this.dialog.open(RecieveDetaileComponent, {
      width: '85rem',
      height: 'auto',
      data: {
        'type_task': type_task,
        'id': id,
        'i': i,
        'code': this.code,
        'sum': this.remain,
        'reception_number': this.id2,
        'ref': 'reception'
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        this.get_balance();
      }
    )
  }
  //****************************************************************************************** */
  open_exit() {
    const dialogRef = this.dialog.open(WharehouseExit2Component, {
      'width': '84rem',
      'height': 'auto',
      data: {
        'reception_id': this.id,
        'token': this.token,
        'code': this.code,
        'creator': this.creator,
        'level': this.level
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (res.isprint == 1) window.open(this.serverService.get_my_domain() + "/tracking2/" + this.id + "/" + res.result.repairman_reception_code, "_blank");
          this.discount_material = res.result.repairman_reception_invoice_discount_material;
          this.discount_services = res.result.repairman_reception_invoice_discount_service;
          this.sum = res.result.repairman_reception_invoice_sum;
          this.get_balance();
        }
      }
    )
  }
  //****************************************************************************************** */
  empty_shelf(shelf: any, type: string) {
    var obj = {
      'address': 1811,
      'shelf': shelf,
      'type': type,
      'id': this.id,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close({ result: this.result });
          //this.serverService.send_reception_repairman();
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
